<template>
<div id="search-container" >

    <div class="search-wrapper-v2" >

        <div class="search-section search-options">

            <div class="search-el search-heading">
                Search
            </div>

            <div class="search-el">
                <span>Show results matching:</span>
                <ul>
                    <li>
                        <label>
                            <input type="radio" name="results-matching" id="all-matching" >
                            All Search Terms
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="radio" name="results-matching" id="any-matching" >
                            Any Search Terms
                        </label>
                    </li>
                </ul>
            </div>

            <div class="search-el border">
                <label for="fact-check-search" class="block" >Search:</label>
                <input type="text" name="fact-check-search" id="fact-check-search" placeholder="Search" >
            </div>

            <div class="search-el border">
                <label for="date_range" class="block" >Date Range:</label>
                <flat-pickr v-model="date_range" name="date_range" id="date_range" placeholder="Date Range"></flat-pickr>
            </div>

            <div class="search-el border">
                <label for="fact-check-search" class="block" >Claim Verdirct:</label>
                <multiselect v-model="claim_value" :options="claim_options"></multiselect>
            </div>

            <div class="search-el border">
                <label for="fact-check-search" class="block" >Claim Type:</label>
                <div class="checkbox-grid">
                    <label v-for="(opt, index) in claim_type_opts" :key="index" >
                        <input type="checkbox" :name="`claim_type-${index}`" :id="`claim_type-${index}`" :value="opt.value" >
                        {{opt.name}}
                    </label>
                </div>
            </div>

            <div class="search-el border">
                <label for="fact-check-search" class="block" >Claim Source:</label>
                <multiselect v-model="claim_value" :options="claim_options"></multiselect>
            </div>

            <div class="search-el border">
                <label for="fact-check-search" class="block" >Source Type:</label>
                <div class="checkbox-grid">
                    <label v-for="(opt, index) in source_type_opts" :key="index" >
                        <input type="checkbox" :name="`claim_type-${index}`" :id="`claim_type-${index}`" :value="opt.value" >
                        {{opt.name}}
                        <div v-if="opt.children" class="child-options" >
                            <label v-for="(child, index2) in opt.children" :key="index2" >
                                <input type="checkbox" :name="`claim_type_child-${index}-${index2}`" :id="`claim_type_child-${index}-${index2}`" :value="child.value" >
                                {{ child.name }}
                            </label>
                        </div>
                    </label>
                </div>
            </div>

        </div>

        <div class="search-section search-results">
            <div id="polling-data-rcp">
                <table class="data large fc_top_label" >
                    <thead>
                        <tr class="header">
                            <th>
                                <span>Fact Checker</span>
                            </th>
                            <th>
                                <span>Relevant Checks</span>
                            </th>
                            <th>
                                <span>Claim of Fact</span>
                            </th>
                            <th>
                                <span>Source of Claim</span>
                            </th>
                            <th>
                                <span>Evidence for Verdict</span>
                            </th>
                            <th>
                                <span>Source for Verdict</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class=""><td>Politifact</td> <td>692</td> <td>98%</td> <td><div class="claim_source_averages">1% Donald Trump</div><div class="claim_source_averages">1% Gateway Pundit</div><div class="claim_source_averages">1% Meme</div><div class="claim_source_averages">1% Beth Wessel-Kroeshell</div><div class="claim_source_averages">1% Douglas Frank</div></td> <td><div>38% Media</div><div>28% Government</div><div>8% University</div><div>8% Fact Checker</div><div>7% Nonprofit</div></td> <td><div>6% Politifact</div><div>2% New York Times</div><div>2% Washington Post</div><div>2% Associated Press</div><div>2% Centers for Disease Control and Prevention</div></td></tr>

                        <tr class="alt"><td>Snopes</td> <td>617</td> <td>98%</td> <td><div class="claim_source_averages">2% Meme</div><div class="claim_source_averages">2% Social Media Posts</div><div class="claim_source_averages">1% Fox News</div><div class="claim_source_averages">1% Donald Trump</div><div class="claim_source_averages">1% Agon Hare</div></td> <td><div>51% Media</div><div>22% Government</div><div>8% Fact Checker</div><div>5% Nonprofit</div><div>5% Business</div></td> <td><div>10% Snopes</div><div>4% Associated Press</div><div>3% New York Times</div><div>2% Washington Post</div><div>2% CNN</div></td></tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>

</div>
</template>

<script>

/**
 * @see https://www.npmjs.com/package/vue-flatpickr-component
 */
import Flatpickr from 'vue-flatpickr-component';

/**
 * @see https://vue-multiselect.js.org/#sub-getting-started
 */
import Multiselect from 'vue-multiselect';

export default {
    name: 'fact-check-search',
    components: {
        'flat-pickr': Flatpickr,
        'multiselect': Multiselect,
    },
    data() {
        return {
            date_range: '',  

            claim_value: '',
            claim_options: [],

            claim_type_opts: [
                {
                    name: 'Political',
                    value: 'political',
                },
                {
                    name: 'Cultural',
                    value: 'political',
                },
                {
                    name: 'Scientific',
                    value: 'political',
                },
                {
                    name: 'Economic',
                    value: 'political',
                },
                {
                    name: 'Fact',
                    value: 'political',
                },
                {
                    name: 'Opinion',
                    value: 'political',
                },
                {
                    name: 'Projection',
                    value: 'political',
                },
            ],

            source_type_opts: [
                {
                    name: 'Social Media',
                    value: 'political',
                },
                {
                    name: 'Think Thank',
                    value: 'political',
                    children: [
                        {
                            name: 'Left',
                            value: 'left',
                        },
                        {
                            name: 'Right',
                            value: 'left',
                        },
                        {
                            name: 'Center',
                            value: 'left',
                        },
                    ],
                },
                {
                    name: 'Media',
                    value: 'political',
                    children: [
                        {
                            name: 'Left',
                            value: 'left',
                        },
                        {
                            name: 'Right',
                            value: 'left',
                        },
                        {
                            name: 'Center',
                            value: 'left',
                        },
                        {
                            name: 'Satire',
                            value: 'left',
                        },
                    ],
                },
                {
                    name: 'Business',
                    value: 'political',
                },
                {
                    name: 'University',
                    value: 'political',
                },
                {
                    name: 'Nonprofit',
                    value: 'political',
                    children: [
                        {
                            name: 'Left',
                            value: 'left',
                        },
                        {
                            name: 'Right',
                            value: 'left',
                        },
                        {
                            name: 'Center',
                            value: 'left',
                        },
                    ],
                },
                {
                    name: 'Other',
                    value: 'political',
                },
                {
                    name: 'Government',
                    value: 'political',
                    children: [
                        {
                            name: 'Republican',
                            value: 'left',
                        },
                        {
                            name: 'Democrat',
                            value: 'left',
                        },
                        {
                            name: 'Libertarian',
                            value: 'left',
                        },
                        {
                            name: 'Green',
                            value: 'left',
                        },
                        {
                            name: 'Independent',
                            value: 'left',
                        },
                        {
                            name: 'Other',
                            value: 'left',
                        },
                        {
                            name: 'National',
                            value: 'left',
                        },
                        {
                            name: 'State',
                            value: 'left',
                        },
                        {
                            name: 'Local',
                            value: 'left',
                        },
                    ],
                },
            ],
        };
    },
}
</script>

<style lang="scss">
@import 'flatpickr/dist/flatpickr.css';
@import 'flatpickr/dist/themes/airbnb.css';
@import "vue-multiselect/dist/vue-multiselect.min.css";

#search-container{

    .search-wrapper-v2{
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .search-section{

            &.search-options{
                margin-right: 20px;
                flex-basis: 30%;
                min-width: 300px;
            }

            &.search-results{
                flex-basis: 70%;
            }

            .search-el{
                margin-bottom: 10px;

                &.search-heading {
                    background-color: #ddd;
                    padding: 10px;
                    font-weight: 600;
                    font-size: 1.2em;
                }

                .checkbox-grid{
                    display: flex;
                    justify-content: flex-start;
                    flex-direction: row;
                    flex-wrap: wrap;

                    & > *{
                        flex-basis: 150px;
                    }

                    .child-options{
                        display: flex;
                        justify-content: flex-start;
                        flex-direction: column;
                        margin-left: 20px;
                    }
                }
            }

        }

    }

    ul{
        padding-inline-start: 0px;
        margin-block: 0px;
    }

    .block{
        display: block;
    }
}
</style>